import type { AxiosResponse } from 'axios';
import axios from '@/utils/axios';
import { GetBrandResponse } from '@/types/response';
import handleAPIError from '@/services/errorHandler';

export function getBrand(id: string): Promise<GetBrandResponse> {
  return axios.get(`/en/v1/brands/${id}`)
    .then(((res: AxiosResponse<GetBrandResponse>) => res.data))
    .catch(handleAPIError);
}
